import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '@config/firebase';

const ERROR_LOGS_COLLECTION = 'error_logs';
const MAX_ERRORS_PER_HOUR = 10;

// Track error counts per hour for rate limiting
let errorCount = 0;
let errorWindowStart = Date.now();

function isRateLimited(): boolean {
  const now = Date.now();
  const oneHour = 60 * 60 * 1000;

  // Reset window if an hour has passed
  if (now - errorWindowStart > oneHour) {
    errorCount = 0;
    errorWindowStart = now;
  }

  if (errorCount >= MAX_ERRORS_PER_HOUR) {
    return true;
  }

  errorCount++;
  return false;
}

interface ErrorContext {
  component?: string;
  action?: string;
  extra?: Record<string, unknown>;
}

export async function logError(error: unknown, context?: ErrorContext): Promise<void> {
  try {
    if (isRateLimited()) return;

    const userId = auth.currentUser?.uid ?? null;
    if (!userId) return; // Only log for authenticated users

    const errorObj = error instanceof Error ? error : new Error(String(error));

    await addDoc(collection(db, ERROR_LOGS_COLLECTION), {
      message: errorObj.message,
      stack: errorObj.stack ?? null,
      userId,
      timestamp: serverTimestamp(),
      url: window.location.href,
      route: window.location.pathname,
      userAgent: navigator.userAgent,
      component: context?.component ?? null,
      action: context?.action ?? null,
      extra: context?.extra ?? null,
    });
  } catch {
    // Silently fail — logging should never crash the app
  }
}
